
/**
 * Filter topics user cannot view from an article, resource, or faq
 * @param {Object} item
 * @param {Object} userTopics
 * @return {Object} returns items and filtered topics
 */
function filterItemTopics (item, userTopics) {
  return {
    ...item,
    topics: item.topics.filter(topic => userTopics.map(userTopic => userTopic.id).includes(topic.id))
  }
}

export { filterItemTopics }
